const InsightsTOC = () => {
  const eleClass = 'm-insights-toc';
  const tocWrappers = document.querySelectorAll(`.${eleClass}`);

  if (!tocWrappers.length) {
    return;
  }

  const scrollHandlers = [];

  /**
   * Prevents refiring too often on a quick resize.
   * @param {Function} func The function to debounce.
   * @param {number} delay The delay in milliseconds.
   * @returns {Function} The debounced function.
   */
  const debounce = (func, delay = 100) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  tocWrappers.forEach(tocWrapper => {
    const tocHeader = tocWrapper.querySelector(`.${eleClass}__header`);
    const tocProgressBar = tocWrapper.querySelector(`.${eleClass}__progress-bar`);
    const tocCurrentNumber = tocWrapper.querySelector(`.${eleClass}__current-number`);
    const tocCurrentTitle = tocWrapper.querySelector(`.${eleClass}__current-title`);
    const tocListItems = tocWrapper.querySelectorAll(`.${eleClass}__list-item`);
    const contentSelector = tocWrapper.dataset.contentContainer || '.insights-content';
    const contentContainer = document.querySelector(contentSelector);

    if (!tocHeader || !contentContainer || !tocProgressBar) {
      console.warn('InsightsTOC instance is missing required elements and was skipped.', tocWrapper);
      return;
    }

    const handleToggleClick = () => {
      tocWrapper.classList.toggle('expanded');
    };

    const updateActiveItem = (activeId) => {
      const activeListItem = tocWrapper.querySelector(`.${eleClass}__list-item[data-target-id="${activeId}"]`);
      if (activeListItem) {
        const numberElement = activeListItem.querySelector(`.${eleClass}__list-item__number`);
        const titleElement = activeListItem.querySelector(`.${eleClass}__list-item__text`);
        if (numberElement && titleElement) {
          tocCurrentNumber.textContent = numberElement.textContent;
          tocCurrentTitle.textContent = titleElement.textContent;
        }
        tocListItems.forEach(item => {
          item.classList.toggle('active', item.dataset.targetId === activeId);
        });
      }
    };

    const handleScroll = () => {
      const contentRect = contentContainer.getBoundingClientRect();
      const contentStart = contentRect.top + window.scrollY;
      const scrollableDistance = contentContainer.offsetHeight;
      const progressWithinContent = window.scrollY - contentStart;
      const progress = Math.max(0, Math.min(100, (progressWithinContent / scrollableDistance) * 100));

      tocProgressBar.style.width = `${progress}%`;

      let currentActiveId = null;
      const isMobileOrTablet = window.innerWidth < 1024;
      const activationOffset = isMobileOrTablet ? 200 : 60;

      for (const item of tocListItems) {
        const sectionId = item.dataset.targetId;
        const heading = document.getElementById(sectionId);
        if (heading && heading.getBoundingClientRect().top <= activationOffset) {
          currentActiveId = sectionId;
        }
      }

      if (currentActiveId) {
        updateActiveItem(currentActiveId);
      }
    };

    scrollHandlers.push(handleScroll);
    tocHeader.addEventListener('click', handleToggleClick);

    tocListItems.forEach(item => {
      const targetId = item.dataset.targetId;
      if (!targetId) return;

      item.addEventListener('click', () => {
        const targetElement = document.getElementById(targetId);
        const isMobileOrTablet = window.innerWidth < 1024;
        if (targetElement) {
          if (!isMobileOrTablet) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          } else {
            const headerOffset = 390
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          }

          tocWrapper.classList.remove('expanded');
        }
      });
    });

    handleScroll();
  });

  const updateAllInstances = () => {
    for (const handler of scrollHandlers) {
      handler();
    }
  };

  window.addEventListener('scroll', updateAllInstances, { passive: true });
  window.addEventListener('resize', debounce(updateAllInstances, 150));
};

export default InsightsTOC;
